import { dataConfigType } from './data-config';
import { v4 as uuid } from "uuid";

const testdata1 = [
  {
    teamId: 1,
    teamName: "Executive Team",
    managerId: null,
    managerName: "Jack CEOMack",
    level: "1",
    memberCount: 11,
    okrCount: 3,
    okrProgressPercent: 73.25,
    krCount: 14,
    krPastDueCount: 0,
    krNeverUpdatedCount: 0,
    okrExpiredCount: 1,
    // lastEngagement: new Date()
  }, {
    teamId: 2,
    teamName: "Advertising",
    managerId: 1,
    managerName: "Don Draper",
    level: "2",
    memberCount: 5,
    okrCount: 3,
    okrProgressPercent: 68.33,
    krCount: 11,
    krPastDueCount: 2,
    krNeverUpdatedCount: 1,
    okrExpiredCount: 1,
    // lastEngagement: new Date()
  }, {
    teamId: 3,
    teamName: "Development",
    managerId: 1,
    managerName: "Jack CEOMack",
    level: "2",
    memberCount: 11,
    okrCount: 4,
    okrProgressPercent: 44.2,
    krCount: 19,
    krPastDueCount: 1,
    krNeverUpdatedCount: 4,
    okrExpiredCount: 1,
    // lastEngagement: new Date()
  }, {
    teamId: 4,
    teamName: "Growth",
    managerId: 1,
    managerName: "Debbie Maxwell",
    level: "2",
    memberCount: 3,
    okrCount: 3,
    okrProgressPercent: 67.7,
    krCount: 11,
    krPastDueCount: 0,
    krNeverUpdatedCount: 1,
    okrExpiredCount: 1,
    // lastEngagement: new Date()
  }, {
    teamId: 5,
    teamName: "Sales",
    managerId: 1,
    managerName: "Don Draper",
    level: "2",
    memberCount: 11,
    okrCount: 3,
    okrProgressPercent: 70,
    krCount: 14,
    krPastDueCount: 3,
    krNeverUpdatedCount: 0,
    okrExpiredCount: 1,
    // lastEngagement: new Date()
  }, {
    teamId: 6,
    teamName: "Marketing",
    managerId: 1,
    managerName: "Emma Chu",
    level: "2",
    memberCount: 11,
    okrCount: 3,
    okrProgressPercent: 75.55,
    krCount: 14,
    krPastDueCount: 1,
    krNeverUpdatedCount: 0,
    okrExpiredCount: 1,
    // lastEngagement: new Date()
  }, {
    teamId: 7,
    teamName: "Customer Service",
    managerId: 1,
    managerName: "Don Draper",
    level: "2",
    memberCount: 11,
    okrCount: 3,
    okrProgressPercent: 81.4875,
    krCount: 14,
    krPastDueCount: 0,
    krNeverUpdatedCount: 0,
    okrExpiredCount: 1,
    // lastEngagement: new Date()
  }
];

const testdata2 = testdata1.concat([
  {
    teamId: 8,
    teamName: "Consulting",
    managerId: 5,
    managerName: "Edward Johnson",
    level: "3",
    memberCount: 6,
    okrCount: 4,
    okrProgressPercent: 42.375,
    krCount: 7,
    krPastDueCount: 1,
    krNeverUpdatedCount: 1,
    okrExpiredCount: 2,
  }, {
    teamId: 9,
    teamName: "IT",
    managerId: 1,
    managerName: "David Marston",
    level: "2",
    memberCount: 3,
    okrCount: 4,
    okrProgressPercent: 52.233,
    krCount: 6,
    krPastDueCount: 2,
    krNeverUpdatedCount: 1,
    okrExpiredCount: ``,
  }, {
    teamId: 10,
    teamName: "Marketing Analytics",
    managerId: 6,
    managerName: "Muriel Smith",
    level: "3",
    memberCount: 7,
    okrCount: 6,
    okrProgressPercent: 76.66,
    krCount: 8,
    krPastDueCount: 1,
    krNeverUpdatedCount: 3,
    okrExpiredCount: 1,
  }, {
    teamId: 11,
    teamName: "Accounting",
    managerId: 1,
    managerName: "Jacob Redstone",
    level: "2",
    memberCount: 2,
    okrCount: 4,
    okrProgressPercent: 49.5,
    krCount: 4,
    krPastDueCount: 2,
    krNeverUpdatedCount: 1,
    okrExpiredCount: 2,
  }  
]);

const ascendent = (orderBy) => (
  { [orderBy]: a },
  { [orderBy]: b },
) => {
  if (b < a) {
    return 1;
  }
  if (b > a) {
    return -1;
  }
  return 0;
};

const descendant = (orderBy) => (
  { [orderBy]: a },
  { [orderBy]: b },
) => {
  if (b < a) {
    return -1;
  }
  if (b > a) {
    return 1;
  }
  return 0;
};

function formatData(
  data,
  order,
  orderBy,
  page,
  rowsPerPage,
) {
  const items = data.map((row) => ({
    ...row,
    key: row.key || uuid().toString(),
  }));

  const sorted = orderBy
    ? items.sort(order === 'asc' ? ascendent(orderBy) : descendant(orderBy))
    : items;

  return rowsPerPage > 0
    ? sorted.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : items;
}

export const getTestData = (dataType, pageData) => {
  switch (dataType) {
    case dataConfigType.TESTDATA1:
      return { teamStats: formatData(testdata1, pageData.order, pageData.columnName,
        pageData.page, pageData.rowsPerPage), totalTeamCount: testdata1.length };
    case dataConfigType.TESTDATA2:
      return { teamStats: formatData(testdata2, pageData.order, pageData.columnName,
        pageData.page, pageData.rowsPerPage), totalTeamCount: testdata2.length };
    default:
      return {};  
  }
};
